import { Stack, useRouter } from 'expo-router';
import React from 'react';
import { StyleSheet, View } from 'react-native';

import { Sad02Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react-native';
import {
  Button,
  Colors,
  PageContainer,
  TextBold,
  TextReg,
} from '@sunrise-ui/primitives';

export default function NotFoundScreen() {
  const router = useRouter();

  const handlePrimaryPress = () => {
    router.replace('/');
  };

  return (
    <>
      <Stack.Screen options={{ title: 'Page not found' }} />
      <PageContainer scrollable={false}>
        <View style={styles.contentContainer}>
          <HugeiconsIcon icon={Sad02Icon} color={Colors.purple1} size={40} />
          <TextBold style={styles.heading}>
            Looks like this page didn&apos;t RSVP.
          </TextBold>
          <TextReg style={styles.body}>
            It might have moved or the link is outdated.
          </TextReg>
          <View style={styles.actionsRow}>
            <Button onPress={handlePrimaryPress}>Go home</Button>
          </View>
        </View>
      </PageContainer>
    </>
  );
}

const styles = StyleSheet.create({
  contentContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 16,
  },
  heading: {
    fontSize: 22,
    textAlign: 'center',
  },
  body: {
    textAlign: 'center',
    maxWidth: 480,
  },
  actionsRow: {
    flexDirection: 'row',
    gap: 12,
    marginTop: 8,
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
});
